import React, { useState } from 'react';
import { Upload, Progress, Message } from 'tdesign-react';
import COS from 'cos-js-sdk-v5';

const PluginUpdater = () => {
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [messageInfo, setMessageInfo] = useState({ show: false, theme: '', content: '' });
    const [uploadSuccess, setUploadSuccess] = useState(false);
    
    // 腾讯云配置（固定值）
    const secretId = 'AKIDpYzGKRN6h6IH4eEfvypncN0eDalmbDey';
    const secretKey = 'c3HIm3tY1IMCpEPM6ezAAAzbzAcv1vcB';
    const bucket = 'iry-1256349444';
    const region = 'ap-guangzhou';
    const fileName = '抖音私信插件.zip';

    const showMessage = (theme, content) => {
        setMessageInfo({ show: true, theme, content });
        setTimeout(() => {
            setMessageInfo({ show: false, theme: '', content: '' });
        }, 3000);
    };

    const handleUpload = async (file) => {
        if (!file) {
            showMessage('error', '无效的文件');
            return;
        }

        if (!file.name.endsWith('.zip') && !file.name.endsWith('.rar')) {
            showMessage('error', '只能上传ZIP或RAR压缩文件');
            setFileList([]);
            return;
        }

        try {
            setUploading(true);
            setProgress(0);
            setUploadSuccess(false);

            const cos = new COS({
                SecretId: secretId,
                SecretKey: secretKey,
            });

            // 上传文件，使用固定的文件名
            await new Promise((resolve, reject) => {
                cos.putObject({
                    Bucket: bucket,
                    Region: region,
                    Key: fileName,  // 使用固定的文件名
                    Body: file,     // 文件对象
                    onProgress: (info) => {
                        const percent = Math.floor(info.percent * 100);
                        setProgress(percent);
                    }
                }, (err, data) => {
                    if (err) {

                        reject(err);
                    } else {

                        resolve(data);
                    }
                });
            });
            
            showMessage('success', '插件上传成功');
            setUploadSuccess(true);
            
            // 清空文件列表
            setFileList([]);
        } catch (error) {

            showMessage('error', '上传失败，请检查网络连接');
        } finally {
            setUploading(false);
        }
    };

    const handleChange = (files) => {
        setFileList(files);
        
        // 如果有新文件添加，自动上传第一个文件
        if (files.length > 0 && files[0].raw) {
            handleUpload(files[0].raw);
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h3>{uploadSuccess ? '上传成功' : '更新插件'}</h3>
            <p>上传抖音私信插件文件到腾讯云对象存储</p>
            <p style={{ color: '#999', marginBottom: '20px' }}>
                {uploadSuccess 
                    ? '插件已成功上传，如需更新请重新上传文件' 
                    : '注意：选择ZIP或RAR压缩文件后将自动上传，并以"抖音私信插件.zip"的名称保存'}
            </p>

            {messageInfo.show && (
                <Message theme={messageInfo.theme} style={{ marginBottom: '16px' }}>
                    {messageInfo.content}
                </Message>
            )}

            <Upload
                files={fileList}
                onChange={handleChange}
                theme="file"
                multiple={false}
                draggable
                autoUpload={false}
                accept=".zip,.rar"
                disabled={uploading}
                placeholder={uploadSuccess ? "点击或拖拽ZIP/RAR文件到此区域进行重新上传" : "点击或拖拽ZIP/RAR文件到此区域，选择后将自动上传"}
            />

            {uploading && (
                <Progress
                    style={{ margin: '20px 0' }}
                    percentage={progress}
                    theme="line"
                />
            )}
        </div>
    );
};

export default PluginUpdater;
